// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"4aa4a14c","781":"6febd343","836":"2e48fc21"}[chunkId] + ".chunk.css";
};